<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="row">
      <div class="col-12">
        <div class="card card-body">
          <div class="row">
            <div class="col-xl-3 col-12">
              <span>{{ "FROM" | translate }}</span>
              <app-datepickr id="from" [defaultDate]="fromFilter" (onSelect)="takeDate($event, 'from')"></app-datepickr>
            </div>
            <div class="col-xl-3 col-12">
              <span>{{ "TO" | translate }}</span>
              <app-datepickr id="to" [defaultDate]="toFilter" (onSelect)="takeDate($event, 'to')"></app-datepickr>
            </div>
            <div class="col-xl-3 col-12">
              <span>{{ "INSERTED_BY" | translate }}</span>
              <ng-select [(ngModel)]="recruiterFilter" [closeOnSelect]="true" [clearable]="recruiterFilter.length > 0" (clear)="recruiterFilter = '0'">
                <ng-option value="0">{{ "ALL" | translate }}</ng-option>
                <ng-option *ngFor="let recruiter of _userService.recruiter_list" [value]="recruiter.hash">{{ recruiter.complete_name }}</ng-option>
              </ng-select>
            </div>
            <div class="col-xl-2 col-12 pt-05">
              <button class="btn btn-outline-primary mt-1" (click)="filter()">{{ "FILTER" | translate }}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-8 col-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">{{ "GRAPH" | translate }}</h3>
          </div>
          <div class="card-body pt-0 pl-0" *ngIf="showChart">
            <div class="px-2">
              <app-step-counter icon="trending-up" title="TOTAL_INSERTED_CANDIDATES" [count]="totalInsertedCandidates" color="primary"></app-step-counter>
            </div>
            <apx-chart
              *ngIf="chartSeries"
              [series]="chartSeries"
              [chart]="{type: 'bar', height: 380, toolbar: {show: false}}"
              [dataLabels]="barsChartOptions.dataLabels"
              [stroke]="{width: 1, colors: ['#fff']}"
              [colors]="['#82868A', '#FF9E43', '#03CFE7', '#EA5354', '#FF6600', '#28C76F']"
              [plotOptions]="{bar: { barHeight: '100%', distributed: true, horizontal: true, dataLabels: { position: 'bottom' }}}"
              [yaxis]="{ labels: { show: false } }"
              [xaxis]="{ categories: [
                         ('STEPS_STATS.SUITABLES' | translate),
                         ('STEPS_STATS.PROPOSED' | translate),
                         ('STEPS_STATS.CALLS' | translate),
                         ('STEPS_STATS.KO' | translate),
                         ('STEPS_STATS.BARGAININGS' | translate),
                         ('STEPS_STATS.HIRED' | translate)
              ] }"
              [tooltip]="barsChartOptions.tooltip"
            ></apx-chart>
          </div>
          <div class="card-body pt-0" *ngIf="!barsChartOptions || !chartSeries || !showChart">
            <p>{{ 'LOADING_CHART' | translate }}</p>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">{{ "COUNTER" | translate }}</h3>
          </div>
          <div class="card-body pb-1">
            <ng-container *ngIf="totalStepCounter">
              <app-step-counter icon="thumbs-up" title="SUITABLES" [count]="totalStepCounter.suitables"></app-step-counter>
              <app-step-counter icon="arrow-up-right" title="PROPOSED" [count]="totalStepCounter.proposed" color="warning"></app-step-counter>
              <app-step-counter icon="phone-call" title="CALLS" [count]="totalStepCounter.calls" color="info"></app-step-counter>
              <app-step-counter icon="x" title="KO" [count]="totalStepCounter.ko" color="danger"></app-step-counter>
              <app-step-counter icon="file-text" title="BARGAININGS" [count]="totalStepCounter.bargaining" color="primary"></app-step-counter>
              <app-step-counter icon="award" title="HIRED" [count]="totalStepCounter.hired" color="success"></app-step-counter>
            </ng-container>
            <p *ngIf="!totalStepCounter">{{ 'LOADING_COUNTER' | translate }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
